const wellKnown = ['image/svg', 'svg', 'image/svg+xml', 'application/svg+xml', 'application/svg'];

export const isSupportedImage = (mime: string): boolean => {
    if (wellKnown.includes(mime)) {
        return true;
    }

    const elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL(mime).indexOf('data:' + mime) === 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
};
